// extracted by mini-css-extract-plugin
export default {"history_box":"History_history_box__DB4gb","item":"History_item__Llvql","item_active":"History_item_active__cUCq+"};